var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group", class: { "has-error": !!_vm.errorText } },
    [
      _c("label", { staticClass: "control-label col-md-3" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-9" }, [
        _c("input", {
          attrs: {
            id: _vm.id,
            name: _vm.name,
            type: "file",
            accept: _vm.accept
          },
          on: { change: _vm.uploadFile }
        }),
        _vm._v(" "),
        _vm.errorText
          ? _c("span", { staticClass: "help-block" }, [
              _c("p", [_vm._v(" " + _vm._s(_vm.errorText) + " ")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.photoSrc
          ? _c("div", { staticClass: "photo-preview" }, [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: _vm.photoSrc }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button" },
                  on: { click: _vm.removePhoto }
                },
                [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" Usuń\n      ")
                ]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2661c02a", { render: render, staticRenderFns: staticRenderFns })
  }
}